import { BaseClient } from "../../clients/base/BaseClient";
import { DRIVERS_ENDPOINTS } from "./drivers.consts";
import type { InstrumentDriver } from "@skyware-group/iris-api-model";

/**
 * Drivers API Client
 * Handles all driver-related API operations.
 */
export class DriversClient extends BaseClient {
  /**
   * Fetch all supported drivers.
   * @param {AbortSignal | null} signal - Optional abort signal for request cancellation.
   * @returns {Promise<InstrumentDriver[]>} Array of all supported drivers.
   */
  async fetchDrivers(signal?: AbortSignal | null): Promise<InstrumentDriver[]> {
    return this.get<InstrumentDriver[]>(DRIVERS_ENDPOINTS.DRIVERS, {
      signal,
    });
  }
}
